import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import AvailableBooks from "../screens/AvailableBooks";
import BooksBorrowed from "../screens/BooksBorrowed";
import Ionicons from "react-native-vector-icons/Ionicons";
import AddBook from "../screens/AddBook";
import MyBooks from "../screens/MyBooks";
import { useContext, useEffect, useState } from "react";
import { ComNavContext } from "../globalData/ComNavContext";
import { BooksContext } from "../globalData/BooksContext";
import { Alert, Platform, View } from "react-native";
import { listNotifications } from "../src/graphql/queries";
import { API } from "aws-amplify";
import { UserContext } from "../globalData/UserContext";
import { CommunityContext } from "../globalData/ComunityContext";

const Tab = createBottomTabNavigator();

export default function Tabs({ route, navigation }) {
  const communityNavigation = useContext(ComNavContext);
  const booksData = useContext(BooksContext);
  const [newNotif, setNewNotif] = useState(false);
  const userData = useContext(UserContext);
  const communityInfo = useContext(CommunityContext);

  useEffect(() => {
    getNotifications();
  }, []);

  async function getNotifications() {
    const allnotifs = await API.graphql({ query: listNotifications });
    const notifs = allnotifs.data.listNotifications.items;
    notifs.map((notif) => {
      if (
        notif.notificationsRecieverUId == userData.user.data.getUsers.uId &&
        notif.community == communityInfo.currCom.cId
      ) {
        if (notif.status != "read") setNewNotif(true);
      }
    });
  }

  let screen;
  if (route.params != null) screen = route.params;
  else screen = "My Books";
  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused, color, size }) => {
          let iconName;
          if (route.name == "Borrowed") {
            iconName = focused ? "bookmark" : "bookmark-outline";
          } else if (route.name == "Share") {
            iconName = focused ? "share" : "share-outline";
          } else if (route.name == "Available") {
            iconName = focused ? "list-circle" : "list-circle-outline";
          } else if (route.name == "My Books")
            iconName = focused ? "book" : "book-outline";

          return <Ionicons name={iconName} size={size} color={color} />;
        },
        initialRoute: screen.screen,
        tabBarActiveTintColor: "#9DAFD2",
        tabBarInactiveTintColor: "#9B928D",
        tabBarStyle: {
          backgroundColor: "#56494C",
        },
        headerStyle:
          Platform.OS == "web"
            ? {
                backgroundColor: "#E2CFC2",
              }
            : { backgroundColor: "#56494C" },

        headerTintColor: "#A48578",
        headerTitleStyle: {
          fontFamily: "quicksand-bold",
          fontSize: 20,
        },
        headerRight: () => (
          <View style={{ flexDirection: "row" }}>
            <View>
              <Ionicons
                name="notifications"
                size={26}
                style={{ marginRight: 13 }}
                color={"#A48578"}
                onPress={() => {
                  navigation.navigate("Notifications");
                }}
              />
              {newNotif && (
                <View
                  style={{
                    backgroundColor: "red",
                    borderRadius: 50,
                    width: 10,
                    height: 10,
                    marginTop: -27,
                  }}
                />
              )}
            </View>
            <Ionicons
              name="refresh"
              size={26}
              style={{ marginRight: 20 }}
              color={"#A48578"}
              onPress={() => {
                Alert.alert("refreshed!");
                booksData.refreshBooks();
              }}
            />
          </View>
        ),
        headerLeft: () => (
          <View>
            <Ionicons
              name="arrow-back-outline"
              size={26}
              style={{ marginLeft: 10 }}
              color={"#A48578"}
              onPress={() => {
                communityNavigation.communityNav.navigate("Communities");
              }}
            />
          </View>
        ),
      })}
    >
      <Tab.Screen name="Available" component={AvailableBooks} />
      <Tab.Screen name="Share" component={AddBook} />
      <Tab.Screen name="Borrowed" component={BooksBorrowed} />
      <Tab.Screen name="My Books" component={MyBooks} />
    </Tab.Navigator>
  );
}
